import { createContext, useState } from 'react';
import PropTypes from 'prop-types';
import Snackbar from '@mui/material/Snackbar';
import { Alert } from '@mui/material';
import Axios from '../extras/Axios';
import { SNACKBAR_SEVERITY } from '../constants';
import { useEffect } from 'react';
import { useContext } from 'react';
export const AdminContext = createContext();


export const useAuth = () => {
  const { login, logout, isLoged, tokenRefresh } = useContext(AdminContext);

  return { login, logout, isLoged, tokenRefresh };
}

function AdminContextProvider({ children }) {

  const [open, setOpen] = useState(false);
  const [mensaje, setMensaje] = useState('');
  const [tipoAdv, setTipoAdv] = useState('error');
  const [selectedUser, setSelectedUser] = useState(null);
  const [isLoged, setIsLoged] = useState(false);

  const handleClickSnackbar = (mensaje, tipo) => {
    setMensaje(mensaje);
    setTipoAdv(tipo);
    setOpen(true);
  };

  async function login(username, password) {
    const result = await Axios.post('/login', { username, password });
    if (result.status === 200) {
      const tokens = result.data;
      if (tokens) {
        handleClickSnackbar('Ingreso exitoso', SNACKBAR_SEVERITY.success)
        localStorage.setItem("token", tokens.token);
        localStorage.setItem("refreshToken", tokens.refreshToken);
        setIsLoged(true)
        return true;
      }
    }
    if (result.status !== 200) {
      if (result.status === 401) handleClickSnackbar(await result.data, SNACKBAR_SEVERITY.error)
      else {
        handleClickSnackbar(await result.data, SNACKBAR_SEVERITY.warning)
      }
      return false;
    }
  }

  function tokenRefresh() {
    Axios.post('/login/tokenLogin').then(tokens => {
      if (tokens) {
        localStorage.setItem("token", tokens.token);
        localStorage.setItem("refreshToken", tokens.refreshToken);
        setIsLoged(true);
      }
    });
  }

  function logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    setIsLoged(false);
  }

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) setIsLoged(true);
  }, []);

  return (
    <AdminContext.Provider value={{ login, logout, isLoged, selectedUser, setSelectedUser, handleClickSnackbar, tokenRefresh }}>
      {children}
      <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={open} autoHideDuration={6000} onClose={handleCloseSnackbar}>
        <Alert onClose={handleCloseSnackbar} severity={tipoAdv}>
          {mensaje}
        </Alert>
      </Snackbar>
    </AdminContext.Provider>
  );
}

AdminContextProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export default AdminContextProvider;
